import { render, staticRenderFns } from "./delete-edition-modal.vue?vue&type=template&id=5deacfca&scoped=true&"
import script from "./delete-edition-modal.vue?vue&type=script&lang=ts&"
export * from "./delete-edition-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5deacfca",
  null
  
)

export default component.exports